import { Button, Grid, GridCol, Menu, Tooltip } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';
import { IconFilter, IconUsersGroup, IconX } from '@tabler/icons-react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { whiteIconButtonStyle } from '../theme/styling/buttonStyling';
import { defaultIconStyle } from '../theme/styling/iconStyling';
import { FormGenericSelector } from './form/FormGenericSelector';

interface ProductFilterButtonProps<T> {
	form: UseFormReturnType<T, (values: T) => T>;
}

export function ProductFilterButton<T>({ form }: ProductFilterButtonProps<T>) {
	const { organisation } = useParams();

	const [opened, setOpened] = useState(false);

	return (
		<>
			<Menu opened={opened} position={'bottom-end'}>
				<Menu.Target>
					<Tooltip label={'Filter products'}>
						<Button
							{...whiteIconButtonStyle}
							onClick={() => setOpened(!opened)}
						>
							{!opened ? (
								<IconFilter {...defaultIconStyle} />
							) : (
								<IconX {...defaultIconStyle} />
							)}
						</Button>
					</Tooltip>
				</Menu.Target>
				<Menu.Dropdown w={'20vw'}>
					<Grid p={10}>
						<GridCol span={12}>
							<FormGenericSelector
								label={'Group'}
								placeholder={'Select group...'}
								icon={<IconUsersGroup {...defaultIconStyle} />}
								form={form}
								property={'groupId'}
								apiRoute={`${organisation}/groups/options`}
							/>
						</GridCol>
						<GridCol span={12}>
							<FormGenericSelector
								label={'Department'}
								placeholder={'Select department...'}
								icon={<IconUsersGroup {...defaultIconStyle} />}
								form={form}
								property={'departmentId'}
								apiRoute={`${organisation}/departments/options`}
							/>
						</GridCol>
						<GridCol span={12}>
							<FormGenericSelector
								label={'Supplier'}
								placeholder={'Select supplier...'}
								icon={<IconUsersGroup {...defaultIconStyle} />}
								form={form}
								property={'supplierId'}
								apiRoute={`${organisation}/supplier/options`}
							/>
						</GridCol>
						<GridCol span={12}>
							<FormGenericSelector
								label={'VAT Rate'}
								placeholder={'Select VAT rate...'}
								icon={<IconUsersGroup {...defaultIconStyle} />}
								form={form}
								property={'vatRateId'}
								apiRoute={`${organisation}/vat-rates/options`}
							/>
						</GridCol>
					</Grid>
				</Menu.Dropdown>
			</Menu>
		</>
	);
}
